import { axiosInstance } from "./axiosInstance";

export const getUsers = async (page, search, role) => {
  try {
    const data = await axiosInstance.get("user/all", {
      params: {
        page: page,
        search: search,
        role: role,
      },
    });
    if (data) {
      return data.data;
    }
    return [];
  } catch (error) {
    throw error;
  }
};
